import { graphql, Link, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import useMediaQuery from '../../hooks/useMediaQuery';
import LandingHeader from '../LandingHeader';
import { NavContext } from '../NavContext';
import NavBarCollapsible from '../NavBarCollapsible';

BlogCategories.propTypes = {
  links: PropTypes.object.isRequired,
};

function BlogCategories({ links }) {
  const { mobileMenu, mobileMenuClick, setMobileMenu } = useContext(NavContext);
  const isTablet = useMediaQuery('(max-width: 1200px)');
  const data = useStaticQuery(graphql`
    query categoryTypes {
      allMarkdownRemark {
        group(field: { frontmatter: { category: SELECT } }) {
          fieldValue
          blogCategories: distinct(
            field: { frontmatter: { blogCategory: SELECT } }
          )
        }
      }
    }
  `);
  return (
    <div className={mobileMenu ? 'menu-main menu-open' : 'menu-main'}>
      <span
        label="none"
        className="hamburger"
        role="button"
        tabIndex="0"
        onClick={mobileMenuClick}
        onKeyDown={mobileMenuClick}>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </span>
      <div className="main-nav">
        <ul className="blogCategories">
          {data?.allMarkdownRemark?.group?.map((category) => {
            const formattedCategory = category?.fieldValue
              ?.toLowerCase()
              .replace(/\s+/g, '-')
              .replace(/&/g, 'and');
            return isTablet ? (
              <NavBarCollapsible
                name={category?.fieldValue}
                label={category?.fieldValue}
                to={`/blog/category/${formattedCategory}`}
                defaultOpen={false}>
                {category?.blogCategories?.map((blogCategory) => {
                  const formattedBlogCategory = blogCategory
                    ?.toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/&/g, 'and');
                  return (
                    <Link
                      href={`/blog/category/${formattedCategory}/${formattedBlogCategory}`}
                      onClick={() => setMobileMenu(false)}
                      target="_blank"
                      rel="noopener noreferrer"
                      key={blogCategory}>
                      {blogCategory}
                    </Link>
                  );
                })}
              </NavBarCollapsible>
            ) : (
              <li key={category?.fieldValue} className="dropdown open">
                <a
                  href={`/blog/category/${formattedCategory}`}
                  target="_blank"
                  rel="noopener noreferrer">
                  {category?.fieldValue}

                  {/*  <span className="dropdown-arrow">
                  <svg
                    x="0px"
                    y="0px"
                    viewBox="0 0 10.3 5.9"
                    style={{ enableBackground: 'new 0 0 10.3 5.9' }}>
                    <path
                      className="st0"
                      d="M9.5,0H0.7C0.4,0,0.2,0.2,0.1,0.5S0,1,0.2,1.3l4.4,4.4c0.3,0.3,0.7,0.3,1,0l4.4-4.4c0.2-0.2,0.3-0.5,0.2-0.8
          C10.1,0.2,9.8,0,9.5,0z"
                    />
                  </svg>
                </span> */}
                </a>
                <div className="dropdown-menu">
                  {category?.blogCategories?.map((blogCategory) => {
                    const formattedBlogCategory = blogCategory
                      ?.toLowerCase()
                      .replace(/\s+/g, '-')
                      .replace(/&/g, 'and');
                    return (
                      <a
                        href={`/blog/category/${formattedCategory}/${formattedBlogCategory}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={blogCategory}>
                        {blogCategory}
                      </a>
                    );
                  })}
                </div>
              </li>
            );
          })}
        </ul>
        {mobileMenu && isTablet && (
          <div className="blog-mobile-header">
            {/* <hr /> */}
            {links}
            <LandingHeader mobileBlog />
          </div>
        )}
      </div>
    </div>
  );
}

export default BlogCategories;
